import type { Messages } from "./en";

export const fr: Messages = {
  common: {
    save: "Enregistrer",
    saving: "Enregistrement…",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    add: "Ajouter",
    close: "Fermer",
    confirm: "Confirmer",
    test: "Tester",
    testing: "Test en cours…",
    none: "Aucun",
    loading: "Chargement…",
    name: "Nom",
    email: "E-mail",
    password: "Mot de passe",
    role: "Rôle",
    actions: "Actions",
    copy: "Copier",
    copied: "Copié",
    optional: "facultatif",
    retry: "Réessayer",
    refresh: "Rafraîchir",
    yes: "Oui",
    no: "Non",
    back: "Retour",
    saved: "Enregistré",
    deleted: "Supprimé",
    error: "Une erreur est survenue",
    areYouSure: "Êtes-vous sûr ?",
    irreversible: "Cette action est irréversible.",
    createdAt: "Créé le",
  },
  auth: {
    forgotPassword: "Mot de passe oublié ?",
    forgotTitle: "Réinitialiser votre mot de passe",
    forgotSubtitle: "Saisissez votre email : nous vous enverrons un lien pour choisir un nouveau mot de passe.",
    forgotSubmit: "Envoyer le lien",
    forgotSent: "Si un compte avec mot de passe existe pour {{email}}, un lien de réinitialisation est en route. Consultez votre boîte mail.",
    resetTitle: "Choisir un nouveau mot de passe",
    resetSubtitle: "Vos autres sessions seront déconnectées.",
    resetSubmit: "Enregistrer le mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    passwordResetDone: "Votre mot de passe a été modifié : connectez-vous avec.",
    linkInvalid: "Ce lien est invalide ou a expiré.",
    requestNewLink: "Demander un nouveau lien",
    backToLogin: "Retour à la connexion",
    checkInboxTitle: "Consultez votre boîte mail",
    checkInboxHelp: "Nous avons envoyé un lien de confirmation à {{email}}. Ouvrez-le pour activer votre compte, puis connectez-vous.",
    resendVerification: "Renvoyer le lien",
    verificationResent: "Un nouveau lien est en route.",
    emailVerified: "Votre adresse est confirmée : vous pouvez vous connecter.",
    ssoContinue: "Continuer avec le SSO",
    ssoTitle: "Authentification unique (SSO)",
    ssoSubtitle: "Saisissez votre email professionnel : vous continuez sur le fournisseur d'identité de votre organisation.",
    ssoSubmit: "Continuer",
    ssoBack: "Se connecter avec un mot de passe",
    ssoNoProvider: "L'authentification unique n'est pas configurée pour ce domaine email.",
    ssoNotLinked: "Un compte existe déjà avec cet email et ne peut pas être lié au SSO. Contactez un administrateur.",
    ssoFailed: "L'authentification unique a échoué. Réessayez ou contactez un administrateur.",
    setupTitle: "Bienvenue sur Shipyard",
    setupSubtitle: "Créez le compte administrateur de cette instance.",
    setupSubmit: "Créer l'administrateur",
    loginTitle: "Connexion",
    loginSubmit: "Se connecter",
    signupTitle: "Créer un compte",
    signupSubmit: "Créer le compte",
    noAccount: "Pas encore de compte ?",
    haveAccount: "Déjà un compte ?",
    signup: "S'inscrire",
    login: "Se connecter",
    logout: "Se déconnecter",
    passwordHint: "Au moins 10 caractères",
  },
  nav: {
    audit: "Journal d'audit",
    billing: "Facturation",
    license: "Licence",
    organization: "Organisation",
    apps: "Applications",
    administration: "Administration",
    users: "Utilisateurs",
    credentials: "Accès stores",
    llm: "Fournisseurs LLM",
    git: "Fournisseurs Git",
    instance: "Instance",
    settings: "Mes paramètres",
    apiDocs: "Documentation API",
    theme: "Changer de thème",
    language: "Langue",
    tags: "Tags",
    devices: "Appareils",
  },
  apps: {
    title: "Applications",
    empty: "Aucune application pour le moment.",
    emptyUser: "Vous n'avez accès à aucune application. Demandez à un administrateur.",
    new: "Nouvelle application",
    settings: "Paramètres",
    builds: "Builds",
    all: "Toutes",
    noBuilds: "Aucune build. Déposez un fichier .ipa ou .aab ci-dessus pour commencer.",
    roleViewer: "Lecteur",
    roleManager: "Gestionnaire",
    app: "App",
    identifiers: "Identifiants",
    viewGrid: "Grille",
    viewList: "Liste",
    recentBuilds: "Dernières builds",
    noRecentBuilds: "Aucune build pour le moment.",
    clearFilter: "Retirer le filtre",
    noMatch: "Aucune app n'a ce tag.",
  },
  tags: {
    title: "Tags",
    help: "Partagés par toutes les apps. Les gestionnaires d'une app peuvent créer des tags et les appliquer à leurs apps ; seuls les administrateurs peuvent les renommer ou les supprimer.",
    tag: "Tag",
    apps: "Apps",
    color: "Couleur",
    preview: "Aperçu :",
    namePlaceholder: "ex. Client A",
    edit: "Tags",
    editTitle: "Tags de {{name}}",
    editHelp: "Cliquez sur un tag pour l'ajouter à cette app ou l'en retirer.",
    new: "Nouveau tag",
    create: "Créer le tag",
    noneYet: "Aucun tag pour le moment.",
  },
  publish: {
    noCertificate: "Les builds iOS de cette page ne pourront pas être installées : la clé App Store Connect de l'app n'a pas de certificat de distribution. Un administrateur peut l'ajouter dans Identifiants des stores.",
    noAppleKey: "Les builds iOS de cette page ne pourront pas être installées : aucune clé App Store Connect n'est configurée pour l'app.",
    iosNotInstallable: "Build iOS publiée, mais pas encore installable",
    button: "Page publique",
    appTitle: "Page publique de l'app",
    appHelp: "Une page accessible sans compte via un lien secret. Elle liste les builds que vous marquez comme publiques (icône œil dans la liste des builds) ; les testeurs téléchargent l'APK ou installent la build iOS sur leur iPhone enregistré.",
    buildTitle: "Page publique de {{version}}",
    buildHelp: "Une page accessible sans compte via un lien secret, pour télécharger cette build (APK) ou l'installer sur un iPhone enregistré.",
    publish: "Publier",
    published: "Page publiée",
    link: "Lien secret",
    open: "Ouvrir",
    approval: "Nouveaux iPhone (UDID)",
    approvalHelp: "Les builds iOS sont re-signées pour chaque iPhone enregistré (ad hoc). Apple autorise 100 iPhone par an et par compte développeur.",
    approval_admin: "Attendre la validation d'un administrateur",
    approval_auto: "Les ajouter automatiquement",
    expires: "Expiration",
    expiresHelp: "Facultatif : le lien cesse de fonctionner après cette date.",
    expiresOn: "Expire le {{date}}",
    noExpiry: "Sans expiration",
    autoPublish: "Publier automatiquement les nouvelles builds",
    autoPublishHelp: "Les builds envoyées à partir de maintenant apparaissent directement sur cette page. Les builds existantes ne changent pas.",
    pickBuildsAuto: "Les nouvelles builds sont publiées automatiquement. Masquez ou affichez une build avec l'icône œil dans la liste des builds.",
    pickBuilds: "Choisissez les builds affichées sur cette page avec l'icône œil dans la liste des builds.",
    regenerate: "Nouveau lien",
    regenerateHelp: "Le lien actuel cesse de fonctionner immédiatement. Partagez le nouveau.",
    unpublish: "Dépublier",
    unpublishHelp: "Le lien cesse de fonctionner. Les iPhone enregistrés sont conservés.",
    unpublished: "Page dépubliée",
    buildPublic: "Visible sur la page publique — cliquer pour masquer",
    buildHidden: "Absente de la page publique — cliquer pour l'afficher",
  },
  invitation: {
    title: "Vous êtes invité",
    subtitle: "{{inviter}} vous invite à rejoindre {{organization}} en tant que {{role}}.",
    subtitleNoInviter: "Rejoignez {{organization}} en tant que {{role}}.",
    notFound: "Cette invitation n'existe pas.",
    accepted: "Cette invitation a déjà été utilisée.",
    revoked: "Cette invitation a été révoquée. Demandez-en une nouvelle.",
    expired: "Cette invitation a expiré. Demandez-en une nouvelle.",
    join: "Rejoindre {{organization}}",
    wrongAccount: "Cette invitation est destinée à {{email}}, mais vous êtes connecté en tant que {{current}}. Déconnectez-vous, puis rouvrez le lien.",
    signInToJoin: "Se connecter pour rejoindre",
    createAndJoin: "Créer mon compte et rejoindre",
  },
  public: {
    support: "Support",
    poweredBy: "Propulsé par Shipyard",
    notFound: "Cette page n'existe pas ou a expiré",
    notFoundHelp: "Demandez un nouveau lien à la personne qui vous l'a partagé.",
    expires: "Disponible jusqu'au {{date}}",
    noBuilds: "Aucune build disponible pour le moment.",
    buildNotFound: "Cette build n'est pas disponible",
    allBuilds: "Toutes les builds",
    whatToTest: "À tester",
    openOnIphone: "Ouvrez cette page sur votre iPhone",
    openOnAndroid: "Ouvrez cette page sur votre téléphone Android",
    scanHelp: "Scannez le QR code avec l'appareil photo, ou envoyez-vous le lien.",
    preparing: "Préparation de la build…",
    preparingHelp: "Cela prend généralement une ou deux minutes. La page se met à jour toute seule.",
    failed: "La build n'a pas pu être préparée",
    unavailable: "Indisponible",
    apkReady: "Prête à installer",
    downloadApk: "Télécharger l'APK",
    apkHelp: "Ouvrez le fichier téléchargé pour l'installer. Android peut demander d'autoriser l'installation d'apps depuis votre navigateur.",
    registerTitle: "Enregistrez d'abord cet iPhone",
    registerHelp: "Les builds de test iOS ne s'installent que sur des appareils enregistrés. L'enregistrement partage l'identifiant de cet iPhone (UDID) ; rien n'est installé.",
    registerButton: "Enregistrer cet iPhone",
    registerStep1: "Autorisez le téléchargement du profil de configuration.",
    registerStep2: "Ouvrez Réglages → Profil téléchargé → Installer.",
    registerStep3: "Safari rouvre cette page automatiquement.",
    useSafari: "Ouvrez cette page dans Safari : les autres navigateurs ne peuvent ni enregistrer l'iPhone ni installer l'app.",
    pendingTitle: "{{name}} attend une validation",
    pendingHelp: "Un administrateur doit valider cet iPhone. Gardez cette page ouverte ou revenez plus tard : elle se met à jour toute seule.",
    rejected: "Cet iPhone n'a pas été validé.",
    iosReady: "Prête à installer sur {{name}}",
    install: "Installer",
    installHelp: "Confirmez l'installation, puis retrouvez l'app sur l'écran d'accueil (l'installation continue en arrière-plan).",
  },
  devices: {
    title: "Appareils",
    help: "iPhone enregistrés depuis les pages publiques. Les appareils validés sont ajoutés au compte développeur Apple et aux profils ad hoc (100 iPhone par an et par compte).",
    status: "Statut",
    status_pending: "En attente",
    status_approved: "Validé",
    status_rejected: "Refusé",
    registeredFrom: "Enregistré depuis",
    registeredWith: "Apple : {{names}}",
    approve: "Valider",
    reject: "Refuser",
    certificate: "Certificat de distribution",
    noCertificate: "Aucun",
    addCertificate: "Ajouter",
    replace: "Remplacer",
    certExpires: "expire le {{date}}",
    certificateTitle: "Certificat de distribution (.p12)",
    certificateHelp: "Exportez le certificat Apple Distribution *avec sa clé privée* depuis Trousseau d'accès (.p12). Il re-signe les builds iOS pour les iPhone enregistrés depuis les pages publiques. Chiffré, jamais réaffiché.",
    p12: "Fichier .p12",
  },
  search: {
    title: "Recherche",
    trigger: "Rechercher…",
    placeholder: "Rechercher des apps, tags, numéros de build, actions…",
    noResults: "Aucun résultat.",
    apps: "Apps",
    tags: "Tags",
    builds: "Builds",
    actions: "Actions",
    appsWithTag_one: "{{count}} app",
    appsWithTag_other: "{{count}} apps",
    goApps: "Toutes les apps",
    darkTheme: "Passer au thème sombre",
    lightTheme: "Passer au thème clair",
    language: "Switch to English",
  },
  upload: {
    drop: "Déposez un .ipa ou un .aab ici, ou cliquez pour parcourir",
    dropHint: "Le bundle identifier / package name doit correspondre à cette application.",
    uploading: "Envoi de {{name}}…",
    done: "Build envoyée, publication sur le store en cours…",
    invalidType: "Seuls les fichiers .ipa et .aab sont acceptés",
    commit: "Commit",
    commitHelp: "Commit à partir duquel le binaire a été compilé, utilisé pour les notes de version.",
    notes: "Notes pour les testeurs",
    notesPlaceholder: "Sur quoi les testeurs doivent-ils se concentrer ?",
    prefillAuto: "Générer les notes store (mode automatique)",
    prefillCopy: "Copier les notes de la version précédente",
    options: "Options",
  },
  build: {
    fill: "Remplir…",
    fillCommits: "IA + commits",
    fillCommitsHint: "Rédiger les notes à partir des commits de la build",
    fillTranslate: "Traduire avec l'IA",
    fillTranslateHint: "Traduire une langue vers les autres",
    fillCopy: "Copier la version précédente",
    fillCopyHint: "Notes store de la build précédente, toutes les langues",
    fillNeedsLlm: "Configurez un fournisseur LLM dans les paramètres de l'app",
    fillNeedsLlmGit: "Configurez un LLM et un dépôt git dans les paramètres de l'app",
    copied: "Notes copiées depuis la version précédente",
    translated: "{{count}} langue(s) traduite(s)",
    translateHelp: "Le texte source est traduit dans les langues cochées (modifications non enregistrées incluses).",
    translate: "Traduire",
    translateNothing: "Rédigez d'abord les notes dans une langue.",
    sourceLocale: "Langue source",
    targetLocales: "Traduire vers",
    willOverwrite: "(sera remplacé)",
    source: { llm: "IA", template: "modèle", manual: "manuel", copied: "copié" },
    version: "Version",
    buildNumber: "Build",
    status: "Statut",
    uploadedBy: "Envoyée par",
    uploadedAt: "Envoyée",
    size: "Taille",
    commit: "Commit",
    track: "Piste",
    timeline: "Historique",
    notes: "Notes de version",
    promote: "Promouvoir en production",
    promoteIos: "Soumettre à la review App Store",
    promoteIosHelp: "Crée la version App Store {{version}}, y attache cette build, renseigne « Nouveautés » depuis les notes store et la soumet à la review.",
    promoteAndroidHelp: "Promeut la release depuis la piste {{from}}.",
    releaseMode: "Publication après validation",
    releaseModeManual: "Manuelle (depuis Shipyard)",
    releaseModeAuto: "Automatique",
    targetTrack: "Piste cible",
    rollout: "Déploiement (%)",
    release: "Publier maintenant",
    releaseHelp: "Apple a validé cette version. La publier sur l'App Store maintenant ?",
    retry: "Réessayer",
    delete: "Supprimer la build",
    deleteHelp: "Supprime la build de Shipyard uniquement (pas des stores).",
    fileDeleted: "Binaire supprimé (rétention)",
    error: "Erreur",
    notFound: "Build introuvable",
    noEvents: "Aucun événement.",
    details: "Détails",
    testingNotes: "Testeurs",
    storeNotes: "Store",
    testingNotesHelp: "« À tester » sur TestFlight / notes de version de la piste interne.",
    storeNotesHelp: "« Nouveautés » sur l'App Store / notes de version de la production Google Play.",
    generate: "Générer avec l'IA",
    generating: "Génération…",
    generated: "Notes générées à partir de {{count}} commits",
    saveNotes: "Enregistrer les notes",
    chars: "{{count}} / {{max}} caractères",
    generateMode: "Source",
    modeCommits: "Commits",
    modeTemplate: "Modèle",
    headCommit: "Commit de la build",
    headCommitHelp: "Aucun commit fourni à l'upload : choisissez celui qui a servi à compiler cette build.",
    headCommitHelpSet: "Commit fourni à l'upload. À changer seulement s'il était faux.",
    baseFrom: "Base : build {{version}} ({{build}}), commit {{sha}}.",
    baseNone: "Aucune version publiée avant : les commits les plus récents de la build sont utilisés.",
    baseExplain: "Seuls les commits atteignables depuis le commit de la build et absents de la base sont listés, quelle que soit la branche.",
    baseCommitHelp: "Forcer le commit de base (par ex. pour inclure plus d'historique).",
    sync: {
      testflight: "Les modifications sont envoyées sur TestFlight (« À tester ») à l'enregistrement.",
      play: "Les modifications sont envoyées dans les notes de la piste {{track}} à l'enregistrement.",
      locked: "« Nouveautés » n'est plus modifiable une fois la version soumise à Apple.",
      promotion: "Ces notes seront appliquées lors de la promotion.",
    },
    baseCommit: "Commit de base",
    instructions: "Instructions supplémentaires",
    promoted: "Promotion lancée",
    promotedAt: "Promue le",
  },
  release: {
    open: "Publier iOS + Android",
    title: "Publier sur les 2 stores",
    description: "Promouvoir une build iOS et une build Android ensemble, avec des notes de version rédigées une seule fois pour les deux stores.",
    submit: "Publier sur les 2 stores",
    stepBuilds: "Builds",
    stepNotes: "Notes de version (les 2 stores)",
    stepOptions: "Options",
    noCandidate: "Aucune build prête à être promue",
    versionMismatch: "Versions différentes : iOS {{ios}} / Android {{android}}.",
    candidatesHelp: "Builds en test (traitées par Apple / sur une piste de test Play). La paire la plus récente avec la même version est pré-sélectionnée.",
    commitHelp: "« IA + commits » utilise les commits depuis la dernière release jusqu'à ce commit.",
    notesHelp: "Les mêmes notes sont envoyées sur les deux stores et remplacent les notes store actuelles des deux builds. Google Play accepte {{max}} caractères.",
    noPrevious: "Aucune build précédente n'a de notes store",
    copiedFrom: "Notes copiées depuis {{version}} ({{build}})",
    started: "Publication lancée sur les 2 stores",
  },
  status: {
    uploaded: "Envoyée",
    pushing: "Publication",
    processing: "Traitement",
    testing: "En test",
    promoting: "Promotion",
    in_review: "En review",
    pending_release: "À publier",
    released: "Publiée",
    rejected: "Rejetée",
    failed: "Échec",
    superseded: "Remplacée",
  },
  appSettings: {
    notesFill: "Notes de version à chaque nouvelle build",
    notesFillHelp: "Comment les notes store sont pré-remplies à l'envoi d'une build. Elles restent modifiables avant la promotion.",
    mode_auto: "Automatique (IA + commits)",
    mode_auto_help: "Générées à partir des commits depuis la dernière release, dans toutes les langues. Nécessite un LLM et un dépôt git.",
    mode_copy_previous: "Copier la version précédente",
    mode_copy_previous_help: "Les notes de la build précédente sont recopiées dans toutes les langues. La première build se remplit à la main, les suivantes suivent. Rien à configurer.",
    mode_manual: "Manuel",
    mode_manual_help: "Rien n'est pré-rempli. Sur chaque build : saisie, génération depuis les commits, ou traduction IA d'une langue.",
    autoMissing: "Le mode automatique nécessite : {{tools}}.",
    useDefaultTemplate: "Utiliser le modèle par défaut",
    toolsTitle: "Outils de génération (IA & git)",
    toolsHelp: "Utilisés par le mode automatique et par les actions à la demande sur chaque build (génération depuis les commits, traduction). Facultatifs dans les autres modes.",
    llmProviderHelp: "Rédige et traduit les notes.",
    gitProviderHelp: "Liste les commits entre deux builds.",
    title: "Paramètres de l'application",
    general: "Général",
    ios: "iOS / App Store",
    android: "Android / Google Play",
    members: "Membres",
    bundleId: "Bundle identifier",
    ascAppId: "ID App Store Connect",
    ascAppIdHelp: "Identifiant numérique (App Store Connect → Informations → Identifiant Apple).",
    appleCredential: "Clé API App Store Connect",
    testflightGroups: "Groupes TestFlight",
    testflightGroupsHelp: "Les groupes internes « toutes les builds » reçoivent chaque build automatiquement. Les groupes externes sont soumis à la review bêta.",
    releaseMode: "Publication après validation",
    package: "Package name",
    googleCredential: "Compte de service",
    rollout: "Déploiement production par défaut (%)",
    llmProvider: "Fournisseur LLM",
    gitProvider: "Fournisseur Git",
    gitRepo: "Dépôt",
    gitRepoHelp: "owner/repo (GitHub, Gitea, Bitbucket), groupe/projet (GitLab) ou projet/depot (Azure DevOps).",
    locales: "Langues",
    localesHelp: "Langues des notes de version (codes App Store, convertis automatiquement pour Google Play).",
    platforms: "Plateformes",
    platformsHelp: "Activez au moins une plateforme. Les deux ne sont pas obligatoires : une app peut être iOS seulement ou Android seulement.",
    iosToggleHelp: "Envoi des .ipa sur TestFlight, soumission à la review",
    androidToggleHelp: "Envoi des .aab sur la piste interne, promotion en production",
    packageHelp: "applicationId de l'app. Elle doit déjà exister dans Play Console (première build envoyée à la main).",
    testflightGroupsHelpSave: "Noms ou IDs de groupes. Enregistrez l'ID App Store Connect et la clé API pour les choisir dans la liste.",
    groupInternalAuto: "interne · automatique",
    groupInternal: "interne",
    groupExternal: "externe · review bêta",
    repoDefaultBranch: "Branche par défaut du dépôt",
    gitBranch: "Branche par défaut",
    gitBranchHelp: "Pré-sélectionnée pour choisir le commit d'une build.",
    gitBranchHelpSave: "Enregistrez le dépôt pour choisir la branche dans la liste.",
    comparisonHelp: "Les notes couvrent les commits entre la dernière build passée par le store (même plateforme) et le commit de la build. La branche ne sert qu'à choisir ce commit : la CI doit envoyer le SHA exact qu'elle a compilé.",
    template: "Modèle",
    templateHelp: "Facultatif. Le texte obtenu est ensuite adapté et traduit par l'IA. Variables Handlebars : appName, version, buildNumber, platform, date, commits[] (subject, body, shortSha, author). Vide = l'IA rédige directement à partir des commits.",
    instructions: "Instructions pour le LLM",
    instructionsHelp: "Ton, mots à éviter, vocabulaire produit…",
    deleteApp: "Supprimer l'application",
    deleteAppHelp: "Supprime l'application, toutes ses builds et ses binaires de Shipyard.",
    memberAdd: "Ajouter un membre",
    noMembers: "Seuls les administrateurs ont accès à cette application.",
    created: "Application créée",
  },
  audit: {
    title: "Journal d'audit",
    help: "Qui a fait quoi, et quand : chaque modification et chaque connexion est enregistrée.",
    orgTitle: "Activité de l'organisation",
    instanceTitle: "Activité de l'instance (comptes, licence, connexions)",
    tabOrganization: "Organisation",
    tabInstance: "Instance",
    retention: "Votre plan affiche les {{count}} derniers jours.",
    export: "Exporter en CSV",
    category: "Catégorie",
    allActions: "Toutes les actions",
    actor: "Qui",
    everyone: "Tout le monde",
    from: "Du",
    to: "Au",
    empty: "Aucune activité ne correspond à ces filtres.",
    date: "Date",
    action: "Action",
    target: "Cible",
    details: "Détails",
    loadMore: "Charger plus",
    system: "Système",
    deletedUser: "utilisateur supprimé",
    requiresEnterprise: "Qui a fait quoi et quand, avec filtres et export CSV : nécessite Shipyard Enterprise.",
    requiresPlan: "Qui a fait quoi et quand : disponible avec les plans Pro (30 jours) et Business (1 an, export).",
    categories: {
      build: "Builds",
      release: "Releases jointes",
      app: "Apps",
      keystore: "Keystore Android",
      publication: "Pages publiques",
      tag: "Tags",
      organization: "Organisation et membres",
      apple_credential: "Clés App Store Connect",
      google_credential: "Comptes Google Play",
      llm_provider: "Fournisseurs LLM",
      git_provider: "Fournisseurs Git",
      device: "Appareils",
      sso_provider: "SSO",
      branding: "Marque blanche",
      billing: "Facturation",
      audit: "Journal d'audit",
      auth: "Connexions",
      user: "Utilisateurs",
      license: "Licence",
      settings: "Réglages d'instance",
      instance: "Instance",
    },
    actions: {
      auth_login: "Connexion",
      auth_login_failed: "Échec de connexion",
      auth_logout: "Déconnexion",
      auth_password_reset: "Mot de passe réinitialisé par email",
      organization_invitation_create: "Invitation envoyée",
      organization_invitation_revoke: "Invitation révoquée",
      organization_invitation_accept: "Invitation acceptée",
      instance_setup: "Installation de l'instance",
      instance_audit_export: "Export du journal d'instance",
      user_signup: "Inscription",
      user_create: "Création d'un utilisateur",
      user_update: "Modification d'un utilisateur",
      user_delete: "Suppression d'un utilisateur",
      settings_update: "Modification des réglages d'instance",
      license_install: "Installation d'une licence",
      license_remove: "Retrait de la licence",
      organization_create: "Création de l'organisation",
      organization_update: "Renommage de l'organisation",
      organization_member_add: "Ajout d'un membre",
      organization_member_update: "Changement de rôle d'un membre",
      organization_member_remove: "Retrait d'un membre",
      api_key_create: "Création d'une clé API",
      api_key_revoke: "Révocation d'une clé API",
      app_create: "Création d'une app",
      app_update: "Modification d'une app",
      app_delete: "Suppression d'une app",
      app_members: "Modification des membres d'une app",
      app_tags: "Modification des tags d'une app",
      build_upload: "Envoi d'un build",
      build_retry: "Relance d'un build",
      build_promote: "Promotion d'un build",
      build_release: "Publication d'un build",
      build_delete: "Suppression d'un build",
      build_public: "Visibilité publique d'un build",
      release_joint: "Release iOS + Android",
      keystore_upload: "Envoi du keystore Android",
      keystore_download: "Téléchargement du keystore Android",
      keystore_delete: "Suppression du keystore Android",
      publication_create: "Publication d'une page publique",
      publication_update: "Modification d'une page publique",
      publication_delete: "Retrait d'une page publique",
      tag_create: "Création d'un tag",
      tag_update: "Modification d'un tag",
      tag_delete: "Suppression d'un tag",
      apple_credential_create: "Ajout d'une clé App Store Connect",
      apple_credential_update: "Modification d'une clé App Store Connect",
      apple_credential_delete: "Suppression d'une clé App Store Connect",
      apple_credential_distribution_certificate: "Envoi d'un certificat de distribution",
      apple_credential_distribution_certificate_delete: "Retrait d'un certificat de distribution",
      google_credential_create: "Ajout d'un compte de service Google Play",
      google_credential_update: "Modification d'un compte de service Google Play",
      google_credential_delete: "Suppression d'un compte de service Google Play",
      llm_provider_create: "Ajout d'un fournisseur LLM",
      llm_provider_update: "Modification d'un fournisseur LLM",
      llm_provider_delete: "Suppression d'un fournisseur LLM",
      git_provider_create: "Ajout d'un fournisseur Git",
      git_provider_update: "Modification d'un fournisseur Git",
      git_provider_delete: "Suppression d'un fournisseur Git",
      device_update: "Modification d'un appareil",
      device_delete: "Suppression d'un appareil",
      sso_provider_create: "Ajout d'un fournisseur d'identité",
      sso_provider_update: "Modification de l'obligation SSO",
      sso_provider_delete: "Retrait d'un fournisseur d'identité",
      sso_provider_verify_domain: "Vérification d'un domaine SSO",
      branding_update: "Modification de la marque blanche",
      branding_logo: "Envoi du logo",
      branding_logo_delete: "Retrait du logo",
      billing_checkout: "Début d'abonnement",
      audit_export: "Export du journal d'audit",
    },
  },
  billing: {
    title: "Facturation",
    help: "Plan, usage et abonnement de l'organisation.",
    freeHelp: "Plan gratuit : passez à un plan supérieur pour plus d'apps, de builds et d'éditeurs.",
    renewsOn: "Renouvellement le {{date}}",
    endsOn: "Se termine le {{date}} : vous repassez au plan gratuit, vos données sont conservées.",
    pastDue: "Paiement échoué",
    manage: "Gérer l'abonnement",
    ownersOnly: "Seuls les propriétaires peuvent modifier l'abonnement.",
    seePlans: "Voir les plans",
    current: "Plan actuel",
    unlimited: "illimité",
    unlimitedUsage: "{{used}} (illimité)",
    seatsUsage: "Éditeurs",
    appsUsage: "Apps",
    buildsUsage: "Builds ce mois-ci",
    storageUsage: "Stockage des builds",
    seatsIncluded: "{{count}} éditeurs inclus",
    seatsPaid: "Facturé par éditeur",
    apps: "Apps : {{value}}",
    builds: "Builds par mois : {{value}}",
    storage: "Stockage : {{value}}",
    pricePerSeatMonth: "{{price}} par siège et par mois",
    pricePerSeatYear: "{{price}} par siège et par an",
    subscribeMonthly: "{{plan}}, mensuel",
    subscribeYearly: "{{plan}}, annuel",
    checkoutSuccess: "Merci ! Votre abonnement est en cours d'activation.",
    seatsExplained: "Les éditeurs sont les propriétaires, administrateurs et managers d'app. Les lecteurs sont gratuits et illimités. Les sièges suivent vos membres automatiquement (au prorata).",
    tagline: { free: "Pour essayer Shipyard en petite équipe.", pro: "Pour les équipes qui livrent plusieurs apps.", business: "SSO et contrôles pour les entreprises." },
  },
  branding: {
    title: "Marque blanche",
    help: "Votre nom, logo, couleur et contact support sur les pages publiques (liens secrets) et le profil d'enregistrement des iPhone.",
    requiresEnterprise: "Pages publiques à votre nom, avec votre logo et votre couleur, sans « Propulsé par Shipyard » : nécessite Shipyard Enterprise.",
    displayName: "Nom affiché",
    color: "Couleur principale",
    colorPicker: "Choisir la couleur principale",
    supportUrl: "Lien de support",
    supportEmail: "Email de support",
    logo: "Logo",
    logoHelp: "PNG, JPEG ou WebP, 256 Ko maximum.",
    logoTooLarge: "Le logo doit faire 256 Ko maximum",
    removeLogo: "Retirer",
    hidePoweredBy: "Masquer « Propulsé par Shipyard »",
  },
  sso: {
    title: "Authentification unique (SSO)",
    help: "Les personnes avec un email du domaine se connectent via votre fournisseur d'identité et rejoignent l'organisation en tant que membres.",
    requiresEnterprise: "Connexion via votre fournisseur d'identité (OpenID Connect ou SAML) : nécessite Shipyard Enterprise.",
    add: "Ajouter un fournisseur d'identité",
    protocol: "Protocole",
    domain: "Domaine email",
    domainHelp: "Plusieurs domaines : séparés par des virgules (acme.com,acme.fr).",
    issuer: "URL de l'émetteur (issuer)",
    issuerHelp: "Son document de découverte est lu sur /.well-known/openid-configuration.",
    clientId: "Client ID",
    clientSecret: "Secret client",
    entityId: "Entity ID du fournisseur d'identité",
    entryPoint: "URL de connexion (SSO)",
    cert: "Certificat de signature",
    domainVerified: "Domaine vérifié",
    domainNotVerified: "Domaine non vérifié",
    verifyDomain: "Vérifier le domaine",
    verifyTitle: "Vérifier {{domain}}",
    verifyHelp: "Créez cet enregistrement TXT dans la zone DNS du domaine, puis vérifiez-le. Personne ne peut se connecter via le fournisseur avant.",
    recordName: "Nom de l'enregistrement",
    recordValue: "Valeur",
    check: "Vérifier l'enregistrement",
    verified: "Domaine vérifié : l'authentification unique est active",
    callbackUrl: "URL de redirection à configurer dans le fournisseur d'identité :",
    metadata: "Métadonnées du fournisseur de service",
    enforce: "Imposer l'authentification unique",
    enforceHelp: "La connexion par mot de passe est refusée pour ce domaine (sauf pour les administrateurs de l'instance).",
  },
  license: {
    title: "Licence",
    help: "Shipyard Community est gratuit. Une licence Shipyard Enterprise débloque plusieurs organisations, l'authentification unique (SSO), les pages publiques en marque blanche, le journal d'audit et les validations de mise en production.",
    community: "Édition Community, sans licence.",
    licensedTo: "Licence accordée à {{customer}}.",
    seats: "Sièges",
    seatsUsed: "{{used}} / {{limit}} utilisés",
    seatsUnlimited: "{{used}} utilisés (illimité)",
    expiresAt: "Expire le",
    features: "Fonctionnalités",
    install: "Installer la licence",
    replace: "Remplacer la licence",
    installHelp: "Collez la clé de licence reçue. Elle est vérifiée hors ligne et stockée chiffrée.",
    key: "Clé de licence",
    remove: "Retirer",
    fromEnv: "La licence est définie par la variable d'environnement LICENSE_KEY.",
    requiresEnterprise: "Nécessite Shipyard Enterprise",
    bannerGrace: "La licence Shipyard Enterprise a expiré. Les fonctionnalités Enterprise restent actives jusqu'au {{date}} : renouvelez-la.",
    bannerExpired: "La licence Shipyard Enterprise a expiré : les fonctionnalités Enterprise sont désactivées. Vos données sont conservées.",
    bannerInvalid: "La clé de licence Shipyard Enterprise est invalide.",
    bannerSeats: "{{used}} sièges sont utilisés mais la licence en couvre {{limit}}. Les membres qui consultent seulement les apps sont gratuits.",
    plan: { community: "Community", enterprise: "Enterprise", free: "Gratuit", pro: "Pro", business: "Business" },
    status: { valid: "Valide", grace: "Période de grâce", expired: "Expirée", invalid: "Invalide" },
    feature: { multi_org: "Plusieurs organisations", sso: "SSO", white_label: "Pages en marque blanche", audit_log: "Journal d'audit", audit_export: "Export du journal d'audit", approvals: "Validations de mise en production" },
  },
  org: {
    invite: "Inviter",
    inviteHelp: "La personne reçoit un email pour rejoindre l'organisation, avec ou sans compte.",
    invitationSent: "Invitation envoyée à {{email}}",
    invitationExtended: "Invitation prolongée de 7 jours",
    shareLinkTitle: "Partager le lien d'invitation",
    shareLinkHelp: "Cette instance ne peut pas envoyer d'emails : transmettez ce lien à {{email}}. Il est valable 7 jours.",
    invitationLink: "Lien d'invitation",
    pendingInvitations: "Invitations en attente",
    pendingInvitationsHelp: "Les invitations expirent après 7 jours. Renvoyez-en une pour la prolonger.",
    invitationExpires: "Expire le",
    invitationExpired: "Expirée",
    invitedBy: "Invité par {{name}}",
    copyLink: "Copier le lien",
    resend: "Renvoyer",
    help: "Les apps, identifiants des stores, fournisseurs, tags et appareils appartiennent à l'organisation.",
    rename: "Renommer",
    new: "Nouvelle organisation",
    newHelp: "Vous en devenez propriétaire et basculez dessus.",
    members: "Membres",
    membersHelp: "Les propriétaires et administrateurs gèrent l'organisation et toutes les apps. Les membres ne voient que les apps auxquelles ils sont ajoutés.",
    addMember: "Ajouter un membre",
    addMemberHelp: "La personne doit déjà avoir un compte sur cette instance.",
    memberSince: "Membre depuis",
    roleOwner: "Propriétaire",
    roleAdmin: "Administrateur",
    roleMember: "Membre",
    none: "Aucune organisation",
    noneHelp: "Vous n'êtes membre d'aucune organisation. Demandez à un administrateur de vous ajouter.",
  },
  admin: {
    users: "Utilisateurs",
    newUser: "Nouvel utilisateur",
    admin: "Administrateur",
    user: "Utilisateur",
    disabled: "Désactivé",
    enable: "Activer",
    disable: "Désactiver",
    resetPassword: "Réinitialiser le mot de passe",
    newPassword: "Nouveau mot de passe",
    signup: "Autoriser les inscriptions",
    signupHelp: "Si activé, toute personne accédant à l'instance peut créer un compte. Les nouveaux comptes rejoignent la première organisation en tant que membres, sans accès aux applications.",
    you: "vous",
    apple: "Clés API App Store Connect",
    appleHelp: "App Store Connect → Utilisateurs et accès → Intégrations → Clés d'équipe (rôle Gestionnaire d'apps minimum).",
    google: "Comptes de service Google Play",
    googleHelp: "Compte de service Google Cloud invité dans Play Console → Utilisateurs et autorisations.",
    keyId: "Key ID",
    issuerId: "Issuer ID",
    keyType: "Type de clé",
    keyTeam: "Équipe",
    keyIndividual: "Individuelle",
    p8: "Clé privée (.p8)",
    p8Help: "Collez le contenu ou choisissez le fichier .p8. Stockée chiffrée, jamais réaffichée.",
    serviceAccount: "JSON du compte de service",
    serviceAccountHelp: "Collez le contenu ou choisissez le fichier .json.",
    replaceSecret: "Laisser vide pour conserver le secret actuel",
    chooseFile: "Choisir un fichier",
    llmTitle: "Fournisseurs LLM",
    llmHelp: "Toute API compatible OpenAI : OpenRouter, OpenAI, Mistral, Groq, Ollama…",
    baseUrl: "URL de base",
    apiKey: "Clé API",
    model: "Modèle",
    temperature: "Température",
    gitTitle: "Fournisseurs Git",
    gitHelp: "Utilisés pour lister les commits entre deux builds pour les notes de version.",
    type: "Type",
    token: "Jeton",
    tokenHelp: "Accès en lecture aux dépôts. Bitbucket : utilisateur:app_password. Azure DevOps : jeton d'accès personnel avec la portée Code (Read).",
    baseUrlHelp: "GitHub Enterprise : https://hote/api/v3 · GitLab/Gitea/Forgejo : URL de l'instance · vide pour github.com / gitlab.com / bitbucket.org",
    baseUrlHelpAzure: "URL de l'organisation, obligatoire : https://dev.azure.com/{organisation} (ou https://{organisation}.visualstudio.com). Les dépôts s'écrivent ensuite projet/depot.",
    testOk: "Connexion OK",
    testFailed: "Échec de la vérification",
    instanceTitle: "Instance",
  },
  keystore: {
    title: "Keystore d'upload",
    description: "Archive du keystore utilisé pour signer le .aab avant l'envoi, pour configurer le projet sur une nouvelle machine. Shipyard ne signe jamais les builds.",
    upload: "Stocker le keystore",
    uploadHelp: "Le fichier et les mots de passe sont chiffrés. Seuls les gestionnaires de l'app et les admins peuvent les télécharger.",
    replace: "Remplacer",
    none: "Aucun keystore stocké pour cette app.",
    file: "Fichier keystore",
    importProperties: "Remplir les champs depuis un key.properties existant",
    keyPasswordHelp: "Laisser vide s'il est identique au storePassword",
    updated: "Mis à jour",
    downloadZip: "Télécharger (.zip)",
    delete: "Supprimer le keystore stocké",
    cli: "En ligne de commande (clé API avec le scope keystore:read)",
  },
  commitPicker: {
    branch: "Branche",
    commit: "Commit",
    none: "— Aucun commit —",
    manual: "Saisir un SHA / une référence…",
    pickFromList: "Choisir parmi les commits de la branche",
  },
  settings: {
    emailUnverified: "Votre adresse email n'est pas encore confirmée : confirmez-la pour pouvoir vous connecter via le SSO de votre organisation.",
    password: "Mot de passe",
    passwordSso: "Vous vous connectez via le fournisseur d'identité de votre organisation : il n'y a pas de mot de passe Shipyard à modifier.",
    nameFromIdp: "Géré par votre fournisseur d'identité.",
    title: "Mes paramètres",
    profile: "Profil",
    changePassword: "Changer de mot de passe",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    apiKeys: "Clés API",
    apiKeysHelp: "À utiliser depuis la CI : Authorization: Bearer <clé>. Une clé n'a jamais plus de droits que vous.",
    newKey: "Nouvelle clé API",
    scopes: "Portées",
    restrictApps: "Limiter aux applications",
    allApps: "Toutes mes applications",
    expiresAt: "Expire",
    never: "Jamais",
    lastUsed: "Dernière utilisation",
    tokenCreated: "Copiez cette clé maintenant, elle ne sera plus affichée :",
    revoke: "Révoquer",
    ciExample: "Exemple CI",
  },
  scopes: {
    "apps:read": "Lire les applications",
    "builds:read": "Lire les builds",
    "builds:write": "Envoyer des builds",
    "builds:promote": "Promouvoir des builds",
    "notes:write": "Modifier les notes de version",
    "keystore:read": "Télécharger le keystore Android",
    "keystore:write": "Stocker le keystore Android",
    admin: "Administration",
  },
};
